import { Partnership } from '@/types/apply/Partnership.type'
import { State } from '@/store/apply/state'
import { DEFAULT_FLOW, DEFAULT_LAYOUT } from '@/utils/ApplyAttr'

export function getPartnership(state: any): Partnership {
    return state?.lead?.partnership
}

export function flow(state: State): string {
    return state.flow?.flow ? state.flow.flow.replace('community.', '') : DEFAULT_FLOW
}

export function layout(state: State): string {
    return state.flow?.layout || DEFAULT_LAYOUT
}

export function nextBatchDate(state: State): string | undefined {
    return state.flow?.nextBatchDate
}
